import React, { useState } from "react";
import { useForm } from "react-hook-form";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from "@material-ui/core/Typography";
import Link from '@material-ui/core/Link';
import { makeStyles } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

import { baseUrl, Roles } from "../config";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.primary,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  apiError: {
    color: "#ff1744",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  link: {
    fontWeight: "bold"
  },
}));

export default function GetirMHLoginForm() {
  const [errMessage, setErrMessage] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [isCheckboxChecked, setCheckboxChecked] = useState(false);

  const { register, errors, handleSubmit } = useForm();

  const handleCheckboxChange = (event) => {
    setCheckboxChecked(event.target.checked);
  };

  const onSubmit = (data) => {
    if (!isCheckboxChecked) {
      console.log(isCheckboxChecked);
      alert("Lütfen sözleşmeyi onaylayın.");
      return;
    }

    setLoading(true);

    fetch(`${baseUrl(Roles.GETIR_MH)}/login`, {
      method: "POST",
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message) {
          setErrMessage(data.message);
        } else {
          localStorage.setItem("authToken", data.authToken);
          localStorage.setItem("role", "getirMh");
          window.location.replace("/orders");
        }
      })
      .then(() => setLoading(false))
      .catch((res) => {
        console.log("error", res);
      });
  };
  const classes = useStyles();

  return (
    <>
      <Backdrop className={classes.backdrop} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <form
        className={classes.form}
        noValidate
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          inputRef={register({
            required: true,
          })}
          id="identityNumber"
          label="TC Kimlik No"
          name="identityNumber"
          error={errors.identityNumber}
          helperText={
            errors.identityNumber && "Lütfen TC Kimlik numaranızı giriniz"
          }
          autoFocus
        />
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          inputRef={register({
            required: true,
          })}
          name="password"
          label="Şifre"
          type="password"
          error={errors.password}
          helperText={errors.password && "Lütfen şifrenizi giriniz"}
          id="password"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="agreement"
              id="agreement"
              label="agreement"
              onChange={handleCheckboxChange}
            />
          }
          label={(
            <Typography variant="caption">GetirBelge uygulaması vasıtasıyla yürüteceğim işlemler nezdinde <Link target="_blank" className={classes.link} href="https://cdn.getir.com/GetirBelgeGGTaahhu%CC%88tnamesi_20102021.pdf">Gizlilik ve Güvenlik</Link> Taahhütnamesi’ne uygun olarak hareket edeceğimi kabul ederim.</Typography>
          )}
        />
        {errMessage && (
          <Typography className={classes.apiError}>{errMessage}</Typography>
        )}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          size="large"
          className={classes.submit}
        >
          Giriş Yap
        </Button>
      </form>
    </>
  );
}
